import * as React from 'react';
import Layout from '../../components/Layout';
import Footer from '../../components/Footer';
import Header from '../../components/Header';
import LanguageSwitcher from '../../components/LanguageSwitcher';
import ValuableContentLanding from '../../components/ValuableContentLanding';
import { getVideoSrc } from '../../constants/constants';
import { useTranslation } from 'react-i18next';
import IntroCreatePlaybooksDragAndDrop from '../../components/IntroCreatePlaybooksDragAndDrop';
import PlaybookFeatures from '../../components/PlaybookFeatures';
import InstallApp from '../../components/InstallApp';
import OpinionsFromUsers from '../../components/OpinionsFromUsers';

export default function FiveCommunicativeWheelsPage() {
    const { t, i18n } = useTranslation();

    const drills = [
        //the cat and the mouse
        {
            id: 1,
            title: t('FiveCommunicativeWheelsPage02'),
            // description: t('FiveDrillsManychatPage03'),
            image: '/images/communicativeWheels/1-baselineCut.gif',
            // videoUrl: getVideoSrc('drill-1-2on2-ball-screen-def', i18n.language)
        },
        {
            id: 2,
            title: t('FiveCommunicativeWheelsPage03'),
            // description: t('FiveDrillsManychatPage03'),
            image: '/images/communicativeWheels/2-45Cut.gif',
            // videoUrl: getVideoSrc('drill-1-2on2-ball-screen-def', i18n.language)
        },
        {
            id: 3,
            title: t('FiveCommunicativeWheelsPage04'),
            // description: t('FiveDrillsManychatPage03'),
            image: '/images/communicativeWheels/3-circleMotion.gif',
            // videoUrl: getVideoSrc('drill-1-2on2-ball-screen-def', i18n.language)
        },
        {
            id: 4,
            title: t('FiveCommunicativeWheelsPage05'),
            // description: t('FiveDrillsManychatPage03'),
            image: '/images/communicativeWheels/4-insideSpacing.gif',
            // videoUrl: getVideoSrc('drill-1-2on2-ball-screen-def', i18n.language)
        },
        {
            id: 5,
            title: t('FiveCommunicativeWheelsPage06'),
            // description: t('FiveDrillsManychatPage03'),
            image: '/images/communicativeWheels/5-ice.gif',
            // videoUrl: getVideoSrc('drill-1-2on2-ball-screen-def', i18n.language)
        },
    ];

    return (
        <>
            <Layout>
                <Header />
                <ValuableContentLanding
                    drills={drills}
                    title={t('FiveCommunicativeWheelsPage00')}
                    buttonText={t('FiveCommunicativeWheelsPage01')}
                />
                <IntroCreatePlaybooksDragAndDrop />
                <PlaybookFeatures />
                <InstallApp />
                <OpinionsFromUsers />
                <Footer />
                <LanguageSwitcher />
            </Layout>
        </>
    );
}
